import { useQuery, UseQueryResult } from "react-query";

import { fetchAuthUser } from "../../api/authUser";

import { IUser } from "modules/user/types/entities";

export const AUTH_USER_QUERY_KEY = "/profiles";

export const useAuthUserQuery = (): UseQueryResult<IUser> => {
  const queryResults = useQuery<IUser>(AUTH_USER_QUERY_KEY, fetchAuthUser, {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    cacheTime: Infinity
  });

  return queryResults;
};
